import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Content,
  ProceedButton,
  Loading,
  ButtonContent,
  FieldsContent,
} from "./styles";
import { push } from "connected-react-router";
import ItemGrid from "../../components/common/ItemGrid";
import { useLocation } from "react-router";
import queryString from "query-string";
import FooterContainer from "../../components/common/FooterContainer";
import TitleHeader from "../../components/common/TitleHeader";

const mapStateToProps = ({ dispatch, cignalReducers, globalReducer }) => ({
  dispatch,
  cignalStore: cignalReducers,
  globalStore: globalReducer,
});

const CignalKitScreen = ({ dispatch, cignalStore, globalStore }) => {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const [kitDetails, setKitDetails] = useState({
    product: cignalStore.product,
  });

  const returnFilteredProducts = (products, subcategory) => {
    const filtered = products.filter((products) => {
      return (
        products.subcategory &&
        products.subcategory.toUpperCase() === subcategory.toUpperCase()
      );
    });

    return filtered;
  };

  const onProceed = (product) => {
    dispatch({
      type: "cignal/SET_PRODUCT",
      payload: product,
    });
  };

  useEffect(() => {
    dispatch({
      type: "global/CURRENT_ENDPOINT",
      payload: "BUY PREPAID KIT",
    });
    dispatch({
      type: "cignal/REQUEST_TOKEN",
      payload: {
        userId: params.userId,
        sessionId: params.sessionId,
      },
    });
    dispatch({
      type: "cignal/SET_CATEGORY",
      payload: "KIT",
    });
  }, [dispatch, params.userId, params.sessionId]);

  useEffect(() => {
    if (cignalStore.sessionDetails.sessionToken) {
      dispatch({
        type: "cignal/REQUEST_PRODUCTS",
        payload: {
          token: cignalStore.sessionDetails.sessionToken,
          category: "cignal",
        },
      });
    }
  }, [cignalStore.sessionDetails.sessionToken, dispatch]);

  return (
    <>
      <Content>
        <div>
          <TitleHeader
            title={globalStore.pageTitle}
            type={
              globalStore.sessionDetails &&
              globalStore.sessionDetails.sessionType
            }
          />
          <FieldsContent>
            {cignalStore.loading ? (
              <Loading>Loading ...</Loading>
            ) : (
              cignalStore.products &&
              returnFilteredProducts(cignalStore.products, "KIT").length >
                0 && (
                <ItemGrid
                  list={returnFilteredProducts(cignalStore.products, "KIT")}
                  setter={setKitDetails}
                  value={kitDetails}
                />
              )
            )}
          </FieldsContent>

          <ButtonContent>
            <ProceedButton
              variant="contained"
              onClick={() => {
                dispatch(push("/cignal/fields"));
                onProceed(kitDetails.product);
              }}
              disabled={!kitDetails.product}
            >
              Proceed
            </ProceedButton>
          </ButtonContent>
        </div>
        <FooterContainer />
      </Content>
    </>
  );
};

export default connect(mapStateToProps)(CignalKitScreen);
